/**
 * @module Cart 
 *  Apis must need auth details to trigger url - AuthApi
 */

import store from '@/store/store';
import Env from '@/env';
import AuthApi from '@/Components/Controllers/AuthApis';
import ProductFavouriteApis from '@/Components/Controllers/ProductFavouriteApis';
import LocationFavouriteApis from '@/Components/Controllers/LocationFavouriteApis';
import router from '@/router';
import { _ } from 'core-js';

export default {
  /**
   * 
   * Fetch User detail
   */
  fetchUserDetail() {
    const url = `${Env.loginUrl}/api/v1/users/myProfile`;
    return AuthApi.getApi(url, {
      "auth-token": store.getters.getLoggedInUserToken,
    })
    .then(res =>  res)
    .catch(err => {
      if(err.response && err.response.status && err.response.status == 401){
        // Depending on data redirect
        router.push(this.verifyUserLoginTokenStatus())
      }
      return err;
    });
  },

  /**
   * 
   * Get user all product out of stock notification
   */
  listOutOfstockNotification(location_product_id) {
    const url = `${Env.productUrl}/api/v1/notificationSubscribers/getByProductId`;
    return AuthApi.postApi(url, {
      "app-id": Env.productAppId,
      "app-secret": Env.productAppSecret
    }, {
      location_product_id: location_product_id,
      user_id: store.getters.getLoggedInUserId
    })
      .then(res => res)
      .catch(err => err);
  },

    /**
   * 
   * Get user all product out of stock notification / SAME AS ABOVE BUT NEW
   */
    getOutOfStockFromVariantIds(variants = []) {
      const url = `${Env.productUrl}/api/v1/notificationSubscribers/getByvariant`;
      return AuthApi.postApi(url, {
        "app-id": Env.productAppId,
        "app-secret": Env.productAppSecret
      }, {
        variant_id: variants,
        user_id: store.getters.getLoggedInUserId
      })
        .then(res => res)
        .catch(err => err);
    },


  /**
   * create out of stock notification
   */
  createOutOfstockNotification(data) {
    store.dispatch('spinner/setSpinner', true);
    const url = `${Env.productUrl}/api/v1/notificationSubscribers/`;
    return AuthApi.postApi(url, {
      "app-id": Env.productAppId,
      "app-secret": Env.productAppSecret
    }, data)
      .then(res => {
        store.dispatch('spinner/setSpinner', false);
        return res;
      })
      .catch(err => {
        store.dispatch('spinner/setSpinner', false);
        return err;
      });
  },

  /**
   * Remove out of stock notitification
   */
  removeOutOfstockNotification(id) {
    const url = `${Env.productUrl}/api/v1/notificationSubscribers/${id}`;
    return AuthApi.deleteApi(url, {
      "app-id": Env.productAppId,
      "app-secret": Env.productAppSecret
    })
      .then(res =>  res)
      .catch(err => err );
  },


  /**
 * Update account details
 */
  updateAccount(data) {
    store.dispatch('spinner/setSpinner', true);
    const url = `${Env.loginUrl}/api/v1/users/set_profile`;
    return AuthApi.postApi(url, {
      "auth-token": store.getters.getLoggedInUserToken,
    }, data)
    .then(res => res)
    .catch(err => {
      if(err.response && err.response.status && err.response.status == 401){
        // Depending on data redirect
        router.push(this.verifyUserLoginTokenStatus())
      }
      return err;
    });
  },

  /**
   * Update password confirmation email code
   */
  changePasswordGenerateToken(data) {
    store.dispatch('spinner/setSpinner', true);
    const url = `${Env.loginUrl}/api/v1/users/password_update_code`;
    return AuthApi.postApi(url, '', data)
      .then(res => {
        store.dispatch('spinner/setSpinner', false);
        return res;
      })
      .catch(err => {
        store.dispatch('spinner/setSpinner', false);
        return err;
      });
  },

  /**
   * Update password
   */
  changePassword(data) {
    store.dispatch('spinner/setSpinner', true);
    const url = `${Env.loginUrl}/api/v1/users/change_password`;
    return AuthApi.putApi(url, '', data)
      .then(res => {
        store.dispatch('spinner/setSpinner', false);
        return res;
      })
      .catch(err => {
        store.dispatch('spinner/setSpinner', false);
        return err;
      });
  },

  /**
   * Update password
   */
  resetPasswordWithVerificationToken(data) {
    store.dispatch('spinner/setSpinner', true);
    const url = `${Env.loginUrl}/api/v1/users/reset_password`;
    return AuthApi.postApi(url, '', data)
      .then(res => {
        store.dispatch('spinner/setSpinner', false);
        return res;
      })
      .catch(err => {
        store.dispatch('spinner/setSpinner', false);
        return err;
      });
  },

  /**
   * Send email verification to email address
   */
  sendEmailVerificationCode(data) {
    const url = `${Env.loginUrl}/api/v1/users/email_update_code`;
    return AuthApi.postApi(url, '', data)
      .then(res => res )
      .catch(err => err);
  },

  /**
   * Update account email
   */
  changeEmail(data) {
    const url = `${Env.loginUrl}/api/v1/users/update_email`;
    return AuthApi.putApi(url, '', data)
      .then(res => res )
      .catch(err => err);
  },

  /**
   * Logout
   */
  logout() {
    store.dispatch('spinner/setSpinner', true);
    const url = `${Env.loginUrl}/api/v1/users/logout`;
    return AuthApi.postApi(url, '', {})
      .then(res => {
        store.dispatch('spinner/setSpinner', false);
        return res;
      })
      .catch(err => {
        store.dispatch('spinner/setSpinner', false);
        return err;
      });

  },

  /**
   * Fetch user fav location IDS
   */
  fetchFavLocations() {
    const url = `${Env.loginUrl}/api/v1/userFavouriteLocations`;
    return AuthApi.getApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    })
      .then(async (res) => {
        if (res.data.payload.length > 0) {
          let userFavLocIdsDetailList = await LocationFavouriteApis.favLocationsListByLocationIds(res.data.payload);
          if (userFavLocIdsDetailList.status == 200) {
            return userFavLocIdsDetailList.data.payload;
          } else {
            return [];
          }
        } else {
          store.dispatch('favouritestores/setList', [])
          return [];
        }
      })
      .catch((err) => {
        if(err.response && err.response.status && err.response.status == 401){
          // Depending on data redirect
          router.push(this.verifyUserLoginTokenStatus())
        }
        store.dispatch('favouritestores/setList', [])
        return [];
      });
  },

  /**
   * Add user fav location
   */
  addUserFavLocation(location_id) {
    const url = `${Env.loginUrl}/api/v1/userFavouriteLocations/create`;
    return AuthApi.postApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    }, {
      location_id
    })
      .then(res => {
        this.fetchFavLocations();
        return res;
      })
      .catch(err => {
        if(err.response && err.response.status && err.response.status == 401){
          // Depending on data redirect
          router.push(this.verifyUserLoginTokenStatus())
        }
        return err;
      });
  },

  /**
   * Add user fav location
   */
  userUnFavLocation(location_id) {
    const url = `${Env.loginUrl}/api/v1/userFavouriteLocations/${location_id}/delete`;
    return AuthApi.deleteApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    })
      .then(res => {
        this.fetchFavLocations();
        return res;
      })
      .catch(err => err);
  },

  /**
   * User fetch favourite products
   */
   async fetchFavProducts() {
    const url = `${Env.loginUrl}/api/v1/userFavouriteProducts`;
    return AuthApi.getApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    })
      .then( async (res) => {
        if (res.data.payload.length > 0) {
          // pluck location product ids from result
          let location_product_ids = [];
          res.data.payload.forEach(item => {
            location_product_ids.push(item.location_product_id)
          })
          let listDetail = await ProductFavouriteApis.favProductListByProductIds(location_product_ids);
          if (listDetail.status == 200) {
            return listDetail.data.payload;
          }
          return [];
        } else {
          store.dispatch('favouriteproducts/setList', []);
          return [];
        }
      })
      .catch(() => {
        store.dispatch('favouriteproducts/setList', []);
        return [];
      });
  },

  fetchFavProductsOLD() {
    const url = `${Env.loginUrl}/api/v1/userFavouriteProducts`;
    return AuthApi.getApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    })
      .then(async (res) => {
        if (res.data.payload.length > 0) {
          // pluck location product ids from result
          let location_product_ids = [];
          res.data.payload.forEach(item => {
            location_product_ids.push(item.location_product_id)
          })
          let listDetail = await ProductFavouriteApis.favProductListByProductIds(location_product_ids);
          if (listDetail.status == 200) {
            return listDetail.data.payload;
          }
          return [];
        } else {
          store.dispatch('favouriteproducts/setList', []);
          return [];
        }
      })
      .catch(() => {
        store.dispatch('favouriteproducts/setList', []);
        return [];
      });
  },

  /**
  * User fetch favourite product ids
  */
  addFavProduct({ location_id, location_product_id }) {

    const url = `${Env.loginUrl}/api/v1/userFavouriteProducts/create`;
    return AuthApi.postApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    }, {
      location_id,
      location_product_id
    })
      .then(async (res) => {
        // pubnub will trigger this
       //  await this.fetchFavProducts();
        return res;
      })
      .catch(err => {
        if(err.response && err.response.status && err.response.status == 401){
          // Depending on data redirect
          router.push(this.verifyUserLoginTokenStatus())
        }
        return err;
      });
  },

  /**
   * User fetch favourite product ids
   */
  removeFavProduct({ location_id, location_product_id }) {
    const url = `${Env.loginUrl}/api/v1/userFavouriteProducts/delete`;
    return AuthApi.deleteApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    }, {
      location_id,
      location_product_id,
    })
      .then(res => {
        // this.fetchFavProducts(); pubnub will trigger this
        return res;
      })
      .catch(err => err);
  },

  /**
   * Push user selected filters
   */
   pushUserFilters({ location_id, filters }) {
    const url = `${Env.loginUrl}/api/v1/users/${location_id}/filter`;
    return AuthApi.postApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    }, {
      filter: filters
    })
      .then( res => res )
      .catch( err => {
        if(err.response && err.response.status && err.response.status == 401){
          // Depending on data redirect
          router.push(this.verifyUserLoginTokenStatus())
        }
        return err;
      });
  },

  
  /**
   * add user on location
   */
   addUserLocation(user_id, location_id, query) {
    if(!user_id || !location_id){
      return;
    }
    const url = `${Env.loginUrl}/api/v1/users/${user_id}/add_location`;
    return AuthApi.postApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    }, {
      location_id,
      in_store: query.in_store ? 1 : 0,
    })
      .then( res => res )
      .catch(err => {
        if(err.response && err.response.status && err.response.status == 401){
          // Depending on data redirect
          router.push(this.verifyUserLoginTokenStatus())
        }
        return err;
      });
  },

  /**
   * User Loyality Checkin
   */
  userLoyalityCheckIn(business_id, location_id, location_name) {
    const url = `${Env.loginUrl}/api/v1/users/loyalty_check_in_event`;
    return AuthApi.postApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    }, {
      business_id,
      location_id,
      location_name,
    })
    .then( res => res )
    .catch(err => {
      if(err.response && err.response.status && err.response.status == 401){
        // Depending on data redirect
        //router.push(this.verifyUserLoginTokenStatus())
      }
      return err;
    });
  },

  /**
   * User business casl subscribe
   *  if user subscribe from casl he will be removed from the casel on opt table
   */
   userBusinessCASlsubscribe(business_id) {
    const url = `${Env.loginUrl}/api/v1/users/subscribe_casl`;
    return AuthApi.deleteApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    }, { business_id })
    .then( res => res )
    .catch( err => {
      if(err.response && err.response.status && err.response.status == 401){
        // Depending on data redirect
        router.push(this.verifyUserLoginTokenStatus())
      }
      return err;
    });
  },

  /**
   * User business casl un subscribe
   *  if user subscribe from casl he will be added from the casel on opt table
   */
   userBusinessCASlunsubscribe(business_id) {
    const url = `${Env.loginUrl}/api/v1/users/unsubscribe_casl`;
    return AuthApi.postApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    }, { business_id })
    .then( res => res )
    .catch( err => {
      if(err.response && err.response.status && err.response.status == 401){
        // Depending on data redirect
        router.push(this.verifyUserLoginTokenStatus())
      }
      return err;
    });
  },

  /**
   * User casl by business ID 
   */
  getUserBusinessCASl(business_id) {
    const url = `${Env.loginUrl}/api/v1/users/business/${business_id}/casl`;
    return AuthApi.getApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    })
    .then( res => res )
    .catch( err => {
      if(err.response && err.response.status && err.response.status == 401){
        // Depending on data redirect
        router.push(this.verifyUserLoginTokenStatus())
      }
      return err;
    });
  },
  /**
   * User loyality history
   */
   getUserLoyaltyTransactions({
    business_id,
    page,
    limit
   }) {
    const url = `${Env.loginUrl}/api/v1/users/business/${business_id}/loyalty_transactions?page=${page}&limit=${limit}`;
    return AuthApi.getApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    })
    .then( res => res )
    .catch( err => {
      if(err.response && err.response.status && err.response.status == 401){
        // Depending on data redirect
        router.push(this.verifyUserLoginTokenStatus())
      }
      return err;
    });
  },

  /**
   * Update email phone from budtender 
   */
   updatePhoneEmailVerification(data) {
    const url = `${Env.loginUrl}/api/v1/users/update_verification`;
    return AuthApi.postApi(url, {
      "api-token": Env.loginApiToken,
      "auth-token": store.getters.getLoggedInUserToken,
    }, data)
    .then( res => res )
    .catch( err => {
      if(err.response && err.response.status && err.response.status == 401){
        // Depending on data redirect
        router.push(this.verifyUserLoginTokenStatus())
      }
      return err;
    });
  },

  /**
   * Verify user login token status
   */
   verifyUserLoginTokenStatus() {
      let currentRoute = store.getters['getCurrentRoute'];
      let getInStore = store.getters['getInStore'];
      if(!_.isEmpty(currentRoute) && currentRoute.params && currentRoute.params.business_slug) {
        let storeSlug = currentRoute.params.store_slug ? currentRoute.params.store_slug : store.getters['location/selected'].slug;
        // If all data redirect to store profile
        // logout user if is logged in
        store.dispatch('REMOVE_APP_DATA');
        store.dispatch('snackbar/setSnackbar', {
          type: 'warning', 
          message: 'Your session is expired, please log in again.'
        });
        if(window.pubnub){
          window.pubnub.unsubscribeAll();
        }
        if(storeSlug){
         return {
            name: 'StoreProfile',
            params: {
              business_slug: currentRoute.params.business_slug,
              store_slug: storeSlug,
            },
            query: {
              in_store: getInStore ? 1: 0,
            }
          }
        }
        // If no locaiton data redirect to business 
        return {
          name: 'HomePage',
          params: {
            business_slug: currentRoute.params.business_slug,
          },
          query: {
            in_store: getInStore ? 1: 0,
          }
        };

      } else {
        // fall back to homepage
        return {
          name: 'HomePage',
          params: {
            business_slug: currentRoute.params.business_slug,
          },
          query: {
            in_store: getInStore ? 1: 0,
          }
        };
      }
   }

 
}